// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_d1-0";
export var fileCarousel = "_d1-2";
export var removeFileButton = "_d1-1";